import { render, staticRenderFns } from "./ProductInfos.vue?vue&type=template&id=556b2578&scoped=true&"
import script from "./ProductInfos.vue?vue&type=script&lang=js&"
export * from "./ProductInfos.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfos.vue?vue&type=style&index=0&id=556b2578&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556b2578",
  null
  
)

export default component.exports